import types from 'actions/types'
import {combineReducers} from 'redux'

export const isOpen = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SHOW_PRICING_CALCULATOR_DRAWER:
      return true
    case types.QUOTING_QUOTE_HIDE_PRICING_CALCULATOR_DRAWER:
      return false
    default:
      return state
  }
}

export const orderItem = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SHOW_PRICING_CALCULATOR_DRAWER:
      return action.orderItem || null
    case types.QUOTING_QUOTE_HIDE_PRICING_CALCULATOR_DRAWER:
      return null
    default:
      return state
  }
}

export const mode = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SHOW_PRICING_CALCULATOR_DRAWER:
      return action.mode ?? null
    case types.QUOTING_QUOTE_HIDE_PRICING_CALCULATOR_DRAWER:
      return null
    default:
      return state
  }
}

export const priceListPart = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SHOW_PRICING_CALCULATOR_DRAWER:
      return action.priceListPart || null
    case types.QUOTING_QUOTE_PRICING_CALCULATOR_DRAWER_PART_LOADED:
      return action.part || null
    case types.QUOTING_QUOTE_HIDE_PRICING_CALCULATOR_DRAWER:
      return null
    default:
      return state
  }
}

export const priceListPartLoaded = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_PRICING_CALCULATOR_DRAWER_PART_LOADED:
      return true
    case types.QUOTING_QUOTE_SHOW_PRICING_CALCULATOR_DRAWER:
    case types.QUOTING_QUOTE_HIDE_PRICING_CALCULATOR_DRAWER:
      return false
    default:
      return state
  }
}

export default combineReducers({
  isOpen,
  orderItem,
  mode,
  priceListPart,
  priceListPartLoaded,
})
